<template>
<div class="allCourses">
      <!-- <headerLogin></headerLogin> -->
      <bannerSearch></bannerSearch>
        <div class="bg">
          <div>
             <section>
                <allCourseCards ></allCourseCards>
             </section>
        <div class="divider"></div>
          </div>
   <!-- <footerArea></footerArea> -->
        </div>
</div>
</template>

<script>
import footerArea from '../common/footerArea.vue'
import headerLogin from '../common/headerLogin.vue'
import courseWishlist from '@/components/wishList/courseWishList.vue'
import allCourseCards from './allCourseCards.vue'
import bannerSearch from '../home/bannerSearch.vue'
export default {
  name: 'allCourses',
  components: {
    footerArea,
    headerLogin,
    allCourseCards,
    courseWishlist,
    bannerSearch
  },
  data () {
    return {
    }
  }
}
</script>
<style lang="scss">
.allCourses{
.bg{
  margin-top:-50px;
  padding-top:40px;
  background: linear-gradient(to bottom, #fafafa 0%,#ffffff 100%); 
  }
}
</style>




// WEBPACK FOOTER //
// src/components/course/allCourses.vue?26627ba3